'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQSearchProps {
  onSearch: (query: string) => void;
  totalResults: number;
}

export default function FAQSearch({ onSearch, totalResults }: FAQSearchProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="w-full max-w-2xl mx-auto mb-8">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Icon name="MagnifyingGlassIcon" size={20} className="text-textTertiary" />
          </div>
          <input
            type="text"
            placeholder="Cari soalan anda di sini..."
            className="w-full pl-12 pr-4 py-3 border-2 border-border rounded-lg focus:outline-none focus:border-primary transition-colors duration-300 font-body"
            disabled
          />
        </div>
      </div>
    );
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch(query);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    onSearch('');
  };

  return (
    <div className="w-full max-w-2xl mx-auto mb-8">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <Icon name="MagnifyingGlassIcon" size={20} className="text-textTertiary" />
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Cari soalan anda di sini..."
          className="w-full pl-12 pr-12 py-3 border-2 border-border rounded-lg focus:outline-none focus:border-primary transition-colors duration-300 font-body"
        />
        {searchQuery && (
          <button
            onClick={handleClearSearch}
            className="absolute inset-y-0 right-0 pr-4 flex items-center text-textSecondary hover:text-primary transition-colors duration-300"
            aria-label="Clear search"
          >
            <Icon name="XMarkIcon" size={20} />
          </button>
        )}
      </div>
      {searchQuery && (
        <p className="mt-2 text-sm text-textSecondary font-body">{totalResults} soalan dijumpai</p>
      )}
    </div>
  );
}
